import { render, staticRenderFns } from "./ArticleReplyView.vue?vue&type=template&id=8d271dec&scoped=true&"
import script from "./ArticleReplyView.vue?vue&type=script&lang=ts&"
export * from "./ArticleReplyView.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleReplyView.vue?vue&type=style&index=0&id=8d271dec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d271dec",
  null
  
)

export default component.exports